import { Grid, LayoutGrid, Table, TableCellsMergeIcon } from "lucide-react";
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
} from "@components/common/menu-bar";
import useTranslator from "@hooks/use-translator";

interface Props {
  options: {
    layout: "grid" | "table";
    deleted: boolean;
  };
  handleMenuOptions: (option: "delete" | "layout", value: any) => void;
}

const FilesMenu = ({ options, handleMenuOptions }: Props) => {
  const { translate } = useTranslator();
  const { layout, deleted } = options;

  return (
    <div className="flex items-center gap-3">
      <Menubar className="border-none bg-transparent">
        <MenubarMenu>
          <MenubarTrigger className="flex items-center gap-1 text-sm text-gray-700 border border-gray-300 rounded-md px-2 py-1 hover:border-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all shadow-sm">
            {layout === "grid" ? (
              <LayoutGrid size={14} />
            ) : (
              <Table size={14} />
            )}
            <span>{translate("View")}</span>
          </MenubarTrigger>
          <MenubarContent className="mx-2 bg-white border border-gray-300 shadow-md">
            <MenubarItem
              onClick={() => handleMenuOptions("layout", "grid")}
              className="flex items-center text-sm py-1 px-2 hover:bg-gray-100"
            >
              <LayoutGrid size={14} className="mr-2" />
              {translate("Grid")}
            </MenubarItem>
            <MenubarItem
              onClick={() => handleMenuOptions("layout", "table")}
              className="flex items-center text-sm py-1 px-2 hover:bg-gray-100"
            >
              <Table  size={14} className="mr-2" />
              {translate("Table")}
            </MenubarItem>
          </MenubarContent>
        </MenubarMenu>
      </Menubar>

      <label className="flex items-center text-sm text-gray-700 cursor-pointer gap-1 ">
        <input
          type="checkbox"
          checked={deleted}
          onChange={(e) => handleMenuOptions("delete", e.target.checked)}
          className="mr-2 h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary"
        />
        {translate("Deleted")}
      </label>
    </div>
  );
};

export default FilesMenu;